module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBoldItalic.e4604d1.eot";